import AOS from 'aos';
AOS.init({
    once: true
});

// =======================
// AOS CUSTOM
// =======================
document.addEventListener('DOMContentLoaded', function () {
    // Sostituisci con il selettore corretto del tuo tab, qui usiamo Bootstrap 5
    var tabTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tab"]'));
    tabTriggerList.forEach(function (tabTriggerEl) {
        tabTriggerEl.addEventListener('shown.bs.tab', function (event) {
            // Ottieni l'id del tab attivato
            var targetId = event.target.getAttribute('data-bs-target') || event.target.getAttribute('href');
            if (targetId) {
                var tabPane = document.querySelector(targetId);
                if (tabPane) {
                    // Reset degli elementi AOS all'interno del tab attivato
                    tabPane.querySelectorAll('[data-aos]').forEach(function (el) {
                        el.classList.remove('aos-animate');
                        el.removeAttribute('data-aos-id'); // workaround per AOS 3+
                    });
                    // Re-inizializza AOS solo per questi elementi
                    setTimeout(function () {
                        AOS.refreshHard();
                    }, 250);
                }
            }
        });
    });
});